export const updateUserInfoRoutes = {
  UPDATE_USER: "/user", // PUT (новый API)
};
